/**
 * Reward class to give the player upon completing the quest
 */

export class Reward {
    coins: number;
    constructor(coins: number) {
        this.coins = coins;
    }
}
